/**
 * Scripts relatifs aux filtres
 **/

import utils from '../misc/utils';

$(document).ready(function () {

  let $filters = $('[data-role="filter"]');        // sélectionne tous les filtres
  let $jobFilters = $('[data-role="job-filter"]'); // sélectionne tous les filtres de jobs
  let $jobAds = $('[data-role="job-ad"]');         // sélectionne toutes les annonces d'emploi


  /**
   * Au clic sur un filtre simple (avec renvoi sur une page)
   */
  $filters.on('click', function (e) {

    if ($(this).hasClass("active")) {
      e.preventDefault();
      utils.resetChoice();
    }

  });


  /**
   * Au clic sur un filtre d'annonce d'emploi
   */
  $jobFilters.on('click', function(e) {
    e.preventDefault();

    let selectedFilter = $(this).data('filter');                      // récupère la valeur du data-filter
    let $selectedAds = $('[data-location="' + selectedFilter + '"]'); // sélectionne toutes les annonces filtrées
    let currentCount = $selectedAds.length;                           // compte le nombre d'items sélectionnés
    let placeholder = $('[data-placeholder]').data('placeholder');    // récupère la valeur du placeholder de l'élément

    // si le filtre cliqué est déjà actif
    if ($(this).hasClass("active")) {
      // réaffiche tous les résultats
      showAllJobAds($jobAds);

      // récupère le nb total d'annonces d'emploi
      currentCount = $jobAds.length;
      // Met à jour le nombre de résultats
      utils.displayNbOfItems(currentCount, placeholder);
    } else {
      // affiche uniquement les résultats correspondants au filtre sélectionné
      hideJobAds(selectedFilter, $jobAds);

      // Met à jour le nombre de résultats
      utils.displayNbOfItems(currentCount, placeholder);
    }

    // désactive tous les filtres, sauf le filtre courant
    $jobFilters.not(this).removeClass('active');

    // active uniquement le filtre cliqué
    $(this).toggleClass('active');

  });

});


/**
 * Affiche uniquement les résultats correspondants au filtre de job sélectionné
 * @param selectedFilter (int)
 * @param $jobAds (array)
 */
function hideJobAds(selectedFilter, $jobAds) {

    // annonces sélectionnées
    let $selectedAds = $('[data-location="' + selectedFilter + '"]');
    // masque toutes les annonces
    $jobAds.hide();
    // affiche uniquement les annonces sélectionnées
    $selectedAds.toggle();
}

/**
 * Affiche toutes les annonces d'emploi
 * @param $jobAds (array)
 */
function showAllJobAds ($jobAds) {
  $jobAds.show();
}
